export const COURSE_CONTENT_NAME = "Speed & Acceleration Course";
export const COURSE_LIST_VALUE = 60;
export const COURSE_LIST_CURRENCY = "USD";
